import React from "react";
import { Chart } from "react-google-charts";

export const data = [
  [
    { type: "date", label: "Day" },
    "Gross Revenue",
    "Net Revenue",
  ],
  [new Date(2014, 0), -0.5, 5.7],
  [new Date(2014, 1), 0.4, 8.7],
  [new Date(2014, 2), 0.5, 12],
  [new Date(2014, 3), 2.9, 15.3],
  [new Date(2014, 4), 6.3, 18.6],
  [new Date(2014, 5), 9, 20.9],
  [new Date(2014, 6), 10.6, 19.8],
  [new Date(2014, 7), 10.3, 16.6],
  [new Date(2014, 8), 7.4, 13.3],
];

export const options = {
  chart: {
//    title: "Average Temperatures and Daylight in Iceland Throughout the Year",
  },
  //width: 900,
  height: 250,
  fontName: 'Roboto' , 
  fontSize: 13,
  legend: { position: 'top' },
  colors: ['#2cb4d4','#1787b8','#255b98','#2f306d'],
  series: {
    // Gives each series an axis name that matches the Y-axis below.
    0: { axis: "Temps" },
  //  1: { axis: "Daylight" },
  },
  
  axes: {
    // Adds labels to each axis; they don't have to match the axis names.
    y: {
   //   Temps: { label: "Temps (Celsius)" },
      Daylight: { label: "Daylight" },
    },
  },
   

};

export function CostCharts() {
  return (
    <Chart
      chartType="Line"
      width="100%"
      height="250px"
      data={data}
      options={options}
    />
  );
}
